import React, { useEffect, useRef, useState } from 'react';

const TWEET_URLS = [
  'https://x.com/dandaditya/status/2045066439112155557?s=20',
  'https://x.com/monisharajpal/status/2045016169984545101?s=46',
  'https://x.com/kunalvg/status/2045016842297823630?s=46',
  'https://x.com/kakashisamaaa/status/2045070242091798642?s=46',
  'https://x.com/ravichikaboom/status/2045059557559554303?s=46',
  'https://x.com/simranrambles/status/2045053418935665090?s=20',
  'https://x.com/kadaipaneeeer/status/2044853650477183389?s=20',
  'https://x.com/ErenOnChain/status/2044856728307831057?s=20',
];

const TWITTER_WIDGETS_SRC = 'https://platform.twitter.com/widgets.js';
const TWITTER_SCRIPT_ID = 'twitter-wjs';

const loadTwitterWidgets = () => {
  if (typeof window === 'undefined' || typeof document === 'undefined') return Promise.resolve(null);
  if (window.twttr?.widgets) return Promise.resolve(window.twttr);

  return new Promise((resolve) => {
    const existing = document.getElementById(TWITTER_SCRIPT_ID);
    if (existing) {
      const tryResolve = () => resolve(window.twttr || null);
      existing.addEventListener?.('load', tryResolve, { once: true });
      setTimeout(tryResolve, 0);
      return;
    }

    const script = document.createElement('script');
    script.id = TWITTER_SCRIPT_ID;
    script.src = TWITTER_WIDGETS_SRC;
    script.async = true;
    script.onload = () => resolve(window.twttr || null);
    script.onerror = () => resolve(null);
    document.body.appendChild(script);
  });
};

const getTweetId = (url) => {
  try {
    const match = url.match(/\/status\/(\d+)/);
    return match?.[1] || null;
  } catch {
    return null;
  }
};

const getEmbedSrc = (url) => {
  const id = getTweetId(url);
  if (id) {
    return `https://platform.twitter.com/embed/Tweet.html?dnt=true&theme=light&conversation=none&hide_thread=true&id=${id}`;
  }
  return `https://platform.twitter.com/embed/Tweet.html?dnt=true&theme=light&conversation=none&hide_thread=true&url=${encodeURIComponent(
    url
  )}`;
};

const getEmbedTuning = (url) => {
  const normalized = String(url || '').toLowerCase();
  const isPriorityFooter =
    normalized.includes('://x.com/monisharajpal/') || normalized.includes('://x.com/kunalvg/');

  return {
    viewportHeight: 560,
    iframeHeight: 1250,
    initialScroll: isPriorityFooter ? 'bottom' : 'top',
  };
};

const TwitterExcitementSection = () => {
  const sectionRef = useRef(null);
  const tweetsRef = useRef(null);
  const embedScrollersRef = useRef(new Map());
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(entry.target);
        }
      },
      { threshold: 0.15 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (!isVisible) return;
    if (!tweetsRef.current) return;
    loadTwitterWidgets().then((twttr) => {
      if (twttr?.widgets?.load) twttr.widgets.load(tweetsRef.current);
    });
  }, [isVisible]);

  useEffect(() => {
    if (!isVisible) return;
    const scrollMap = embedScrollersRef.current;

    const applyInitialScroll = () => {
      for (const url of TWEET_URLS) {
        const scroller = scrollMap.get(url);
        if (!scroller) continue;
        const { initialScroll } = getEmbedTuning(url);
        if (initialScroll === 'bottom') {
          scroller.scrollTop = scroller.scrollHeight;
        } else {
          scroller.scrollTop = 0;
        }
      }
    };

    const raf = requestAnimationFrame(() => {
      applyInitialScroll();
      setTimeout(applyInitialScroll, 60);
    });
    return () => cancelAnimationFrame(raf);
  }, [isVisible]);

  return (
    <section
      ref={sectionRef}
      className="relative w-full"
      style={{
        background: '#fafafa',
        padding: 'clamp(44px, 7vw, 60px) var(--page-gutter) clamp(56px, 9vw, 80px)',
        overflow: 'hidden',
      }}
    >
      <div
        style={{
          position: 'absolute',
          inset: 0,
          backgroundImage: 'radial-gradient(circle, #c0c5ce 1px, transparent 1px)',
          backgroundSize: '16px 16px',
          opacity: 0.28,
          pointerEvents: 'none',
          zIndex: 0,
        }}
      />

      <div
        className="relative"
        style={{
          zIndex: 1,
          opacity: isVisible ? 1 : 0,
          transform: isVisible ? 'translateY(0)' : 'translateY(22px)',
          transition: 'opacity 0.7s ease, transform 0.7s ease',
        }}
      >
        <div style={{ maxWidth: 980, margin: '0 auto 28px' }}>
          <h2
            style={{
              fontFamily: 'Coolvetica, sans-serif',
              fontSize: 'clamp(32px, 6.2vw, 56px)',
              fontWeight: 400,
              color: '#000',
              letterSpacing: '-0.035em',
              lineHeight: '1.05',
              textAlign: 'center',
            }}
          >
            we are not the only one who are excited
          </h2>
        </div>

        <div
          ref={tweetsRef}
          className="tweet-scroll"
          style={{
            display: 'flex',
            gap: 'clamp(12px, 2.8vw, 20px)',
            overflowX: 'auto',
            padding: '6px 2px 10px',
            scrollSnapType: 'x mandatory',
            WebkitOverflowScrolling: 'touch',
          }}
        >
          {TWEET_URLS.map((url) => (
            (() => {
              const { viewportHeight, iframeHeight } = getEmbedTuning(url);

              return (
            <div
              key={url}
              className="why-card-macos"
              style={{
                flex: '0 0 auto',
                width: 'min(460px, calc(100vw - 2 * var(--page-gutter)))',
                border: '1px solid #c0c5ce',
                borderRadius: 16,
                background: '#fff',
                padding: 16,
                boxShadow: '0 10px 26px rgba(0,0,0,0.06)',
                scrollSnapAlign: 'start',
                position: 'relative',
                overflow: 'hidden',
                display: 'flex',
                flexDirection: 'column',
                gap: 12,
              }}
            >
              <div
                style={{
                  position: 'relative',
                  zIndex: 1,
                  borderRadius: 12,
                  overflowY: 'auto',
                  overscrollBehavior: 'contain',
                  WebkitOverflowScrolling: 'touch',
                  height: viewportHeight,
                  background: '#fff',
                  touchAction: 'pan-y',
                }}
                ref={(el) => {
                  if (!el) {
                    embedScrollersRef.current.delete(url);
                    return;
                  }
                  embedScrollersRef.current.set(url, el);
                }}
              >
                <iframe
                  title={url}
                  src={getEmbedSrc(url)}
                  loading="lazy"
                  sandbox="allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox"
                  allow="clipboard-write; fullscreen"
                  style={{
                    display: 'block',
                    width: '100%',
                    height: iframeHeight,
                    border: 0,
                    pointerEvents: 'none',
                  }}
                />
                <div
                  style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    height: 18,
                    background: 'linear-gradient(to bottom, rgba(255,255,255,0.98), rgba(255,255,255,0))',
                    pointerEvents: 'none',
                  }}
                />
              </div>

              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'flex-end',
                }}
              >
                <a
                  href={url}
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Open tweet"
                  onClick={(e) => e.stopPropagation()}
                  onKeyDown={(e) => e.stopPropagation()}
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: 8,
                    fontFamily: 'InterVariable, sans-serif',
                    fontSize: 13,
                    lineHeight: '16px',
                    color: '#111',
                    textDecoration: 'none',
                    padding: '8px 10px',
                    borderRadius: 999,
                    border: '1px solid rgba(0,0,0,0.12)',
                    background: '#fff',
                    boxShadow: '0 6px 14px rgba(0,0,0,0.05)',
                  }}
                >
                  <span>Open tweet</span>
                  <span aria-hidden="true" style={{ fontSize: 14, lineHeight: '14px' }}>
                    ↗
                  </span>
                </a>
              </div>
            </div>
              );
            })()
          ))}
        </div>
      </div>
    </section>
  );
};

export default TwitterExcitementSection;
